(function (Drupal, once) {
  Drupal.behaviors.addressFromCoordinates = {
    attach(context) {
      const parseCoordinate = (value) => {
        if (value === undefined || value === null) return null;

        const normalized = value.toString().trim().replace(",", ".");
        const parsed = parseFloat(normalized);

        return Number.isFinite(parsed) ? parsed : null;
      };

      // Check if Google Maps API is fully loaded and constructor is ready.
      const checkGoogleMapsLoaded = (callback, attempts = 40) => {
        const mapConstructor = window.google?.maps?.Map;

        if (typeof mapConstructor === "function") {
          callback();
          return;
        }

        if (attempts <= 0) {
          return;
        }

        setTimeout(() => checkGoogleMapsLoaded(callback, attempts - 1), 250);
      };

      context
        .querySelectorAll("[data-latitude][data-longitude]")
        .forEach((wrapper) => {
          if (wrapper.dataset.geoProcessed) return;
          wrapper.dataset.geoProcessed = "true";

          const mapEl = wrapper.querySelector(".hsl-map");
          const latitude = parseCoordinate(wrapper.dataset.latitude);
          const longitude = parseCoordinate(wrapper.dataset.longitude);

          if (!mapEl || latitude === null || longitude === null) return;

          // Wait for Google Maps API to be available
          checkGoogleMapsLoaded(() => {
            if (typeof window.google?.maps?.Map !== "function") {
              return;
            }

            const coordinates = { lat: latitude, lng: longitude };

            const map = new google.maps.Map(mapEl, {
              zoom: 16,
              center: coordinates,
              language: "pt-BR",
            });

            new google.maps.Marker({
              position: coordinates,
              map: map,
            });
          });
        });
    },
  };
})(Drupal, once);
